import { Component } from '@angular/core';
import { LocaleFacade } from '@rd/core/facades/locale-facade/locale.facade';
import { LoyaltyCurrencyFacade } from '@rd/core/facades/loyalty-currency-facade/loyalty-currency.facade';
import { UnleashFacade } from '@rd/core/facades/unleash-facade/unleash-facade.ts';
import { isNotNull } from '@rd/utils/isNotNull';
import { combineLatest } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'rd-lib-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class WestpacAppComponent {
  isReady$ = combineLatest([
    this.localeFacade.selectedLocale$,
    this.loyaltyCurrencyFacade.getLoyaltyCurrencySelected$.pipe(
      filter(isNotNull),
    ),
    this.unleashFacade.isUnleashClientReady$,
  ]).pipe(map((v) => v.every(Boolean)));

  constructor(
    private localeFacade: LocaleFacade,
    private loyaltyCurrencyFacade: LoyaltyCurrencyFacade,
    private unleashFacade: UnleashFacade,
  ) {}
}
